<template>
  <div class="adminWebsiteConfig">
    <div class="PageHeader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="mode == 'forum'">
          <el-breadcrumb-item>周边论坛</el-breadcrumb-item>
        </template>
        <template v-else>
          <el-breadcrumb-item :to="{ path: '/admin/forum' }"
            >周边论坛</el-breadcrumb-item
          >
          <el-breadcrumb-item>评论</el-breadcrumb-item>
        </template>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('admin_forum.edit')"
          type="success"
          size="small"
          @click="onlineBatch"
          >{{l("上架")}}</el-button
        >
        <el-button
          v-if="$store.getters.checkPermission('admin_forum.edit')"
          type="danger"
          size="small"
          @click="offlineBatch"
          >{{l("下架")}}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>id</label>
          <el-input
            placeholder="请输入id"
            v-model="SearchData.id"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col :span="6">
          <label>内容</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.content"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col v-if="mode == 'forum'" key="tag_id" :span="4">
          <label>{{l("类型")}}</label>
          <el-select
            clearable
            v-model="SearchData.tag_id"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item in $store.state.basicInfo.tagList.forum"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <label>{{l("状态")}}</label>
          <el-select
            clearable
            v-model="SearchData.status"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item in statusList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{l("查询")}}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :width="80"
          :operationList="[
            {
              is_show: (row) => true,
              label: l('详情'),
              command: 'ViewItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column type="selection" width="55" fixed> </el-table-column>

        <el-table-column
          v-if="mode == 'forum'"
          key="tag_id"
          :label="l('类型')"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope"
            >{{
              $utils.listFilter(
                $store.state.basicInfo.tagList.forum,
                scope.row.tag_id
              )
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          :label="l('内容')"
          min-width="250"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-if="mode == 'forum'"
          key="img_array"
          label="图片"
          width="100"
        >
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.img_array[0]"
                :src="scope.row.img_array[0]"
                fit="contain"
                :preview-src-list="scope.row.img_array"
              ></el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="mode == 'discuss'"
          key="is_private"
          label="仅对方可见"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.is_private ? "是" : "-" }}
          </template>
        </el-table-column>

        <el-table-column :label="l('状态')" width="100">
          <template slot-scope="scope">
            <div
              :class="[
                $utils.listFilter(statusList, scope.row.status, 'class'),
              ]"
            >
              {{ $utils.listFilter(statusList, scope.row.status) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="mode == 'forum'"
          key="comment_count"
          label="评论"
          width="80"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.comment_count"
              class="ViewLink"
              @click="goDiscuss(scope.row.id)"
            >
              {{ scope.row.comment_count }}
            </div>
            <div v-else style="color: #999">暂无</div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="mode == 'forum'"
          key="recommend_level"
          label="推广"
          width="80"
          prop="recommend_level"
          sortable="custom"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.recommend_level"
              :true-label="1"
              :false-label="0"
              :disabled="
                !$store.getters.checkPermission('admin_forum.recommend')
              "
              @change="changeRecommend(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_time"
          label="发布时间"
          sortable="custom"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.created_time }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>

    <CreateOrEditAdminForum
      ref="createOrEditDialog"
      :mode="mode"
      @submitDialog="GetTableList"
    />
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminForum from "./operation/CreateOrEditAdminForum.vue";
export default {
  name: "AdminForum",
  mixins: [tableMixin],
  components: { CreateOrEditAdminForum },
  data() {
    return {
      SearchData: {
        id: null,
        content: "",
        tag_id: "",
      },
      statusList: [
        {
          id: -1,
          name: this.l("已下架"),
          class: "color-danger",
        },
        {
          id: 0,
          name: this.l("待审核"),
          class: "color-warning",
        },
        {
          id: 1,
          name: this.l("已上架"),
          class: "color-success",
        },
      ],
    };
  },
  computed: {
    mode() {
      if (this.$route.query.id) {
        return "discuss";
      } else {
        return "forum";
      }
    },
  },
  created() {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      let requestUrl = "";
      if (this.mode == "forum") {
        requestUrl = "/api/admin_forum/post/";
      } else if (this.mode == "discuss") {
        requestUrl =
          "/api/admin_forum/discuss/?forum_id=" + this.$route.query.id;
      }
      this.axios
        .get(requestUrl, {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.img_array = JSON.parse(item.img_array);
            return item;
          });
        });
    },
    onlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待上架的内容"));
      }
      this.$confirm(`${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length}${this.l("项")}${this.l("上架")}?`, "", {
        type: "warning",
      }).then(() => {
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = "/api/admin_forum/post/bulk_on/";
        } else if (this.mode == "discuss") {
          requestUrl = "/api/admin_forum/discuss/bulk_on/";
        }
        this.axios
          .put(
            requestUrl,
            this.MultipleSelection.map((item) => {
              return {
                id: item.id,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待下架的内容"));
      }
      this.$confirm(`${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length}${this.l("项")}${this.l("下架")}?`, "", {
        type: "warning",
      }).then(() => {
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = "/api/admin_forum/post/bulk_off/";
        } else if (this.mode == "discuss") {
          requestUrl = "/api/admin_forum/discuss/bulk_off/";
        }
        this.axios
          .put(
            requestUrl,
            this.MultipleSelection.map((item) => {
              return {
                id: item.id,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    changeRecommend(item) {
      this.$confirm(
        `是否${item.recommend_level ? "推广" : "解除推广"}选中帖子?`,
        "",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .put(`/api/admin_forum/post/${item.id}/recommend/`, {
              recommend_level: item.recommend_level,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },
    goDiscuss(id) {
      this.$router.push("/admin/forum/?id=" + id);
    },
  },
};
</script>

<style scoped lang="scss">
//el-tabs选中标签加粗
/deep/.el-tabs__item.is-active {
  font-weight: bold;
  // color: $warningColor;
}
</style>

